// ValueAndTrustStep.tsx
// Step 1: Value proposition with Free vs Platinum vs AI Platinum comparison

import React from 'react';
import { View, ScrollView, StyleSheet } from 'react-native';
import { Text, Button, ChatAvatar } from '../../../components/ui';
import { Theme } from '../../../utils/theme';
import { PaywallHeader } from '../components/PaywallHeader';
import { ComparisonTable } from '../components/ComparisonTable';
import type { PaywallStepProps } from '../types';

export const ValueAndTrustStep: React.FC<PaywallStepProps> = ({
  onNext,
  onClose,
}) => {
  return (
    <View style={styles.container}>
      <PaywallHeader onClose={onClose} />

      <ScrollView
        style={styles.scrollView}
        contentContainerStyle={styles.scrollContent}
        showsVerticalScrollIndicator={false}
      >
        {/* Hero section with mentor avatar */}
        <View style={styles.hero}>
          <View style={styles.avatarContainer}>
            <ChatAvatar type="mentor" size="large" />
          </View>
          
          <Text variant="h1" style={styles.heroTitle}>
            Unlock Your{'\n'}
            <Text style={styles.heroEmphasis}>Full Potential</Text>
          </Text>
          <Text variant="body1" style={styles.heroSubtitle}>
            Transform your personal growth journey with personalized AI guidance
          </Text>
        </View>

        {/* Comparison table */}
        <View style={styles.comparisonSection}>
          <ComparisonTable />
        </View>

        {/* Trust line */}
        <Text variant="body2" style={styles.trustLine}>
          Easy to cancel. No fees. No commitments.
        </Text>

        {/* CTA */}
        <Button
          title="Continue"
          onPress={onNext}
          style={styles.ctaButton}
        />
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Theme.colors.background,
  },
  scrollView: {
    flex: 1,
  },
  scrollContent: {
    paddingTop: 80,
    paddingHorizontal: Theme.spacing.xxl,
    paddingBottom: Theme.spacing.xxxl,
  },
  hero: {
    alignItems: 'center',
    marginBottom: Theme.spacing.xl,
    backgroundColor: '#E8F9F3', // Mint green like onboarding
    paddingVertical: Theme.spacing.xxxl,
    paddingHorizontal: Theme.spacing.xl,
    borderRadius: Theme.borderRadius.xl,
    marginHorizontal: -Theme.spacing.xxl,
    marginTop: -Theme.spacing.lg,
    ...Theme.shadows.md,
  },
  avatarContainer: {
    marginBottom: Theme.spacing.xl,
  },
  heroTitle: {
    textAlign: 'center',
    marginBottom: Theme.spacing.md,
    color: Theme.colors.textPrimary,
  },
  heroEmphasis: {
    color: Theme.colors.primary,
  },
  heroSubtitle: {
    textAlign: 'center',
    color: Theme.colors.textSecondary,
  },
  comparisonSection: {
    marginBottom: Theme.spacing.xl,
  },
  trustLine: {
    textAlign: 'center',
    color: Theme.colors.textSecondary,
    marginBottom: Theme.spacing.xxl,
    fontStyle: 'italic',
  },
  ctaButton: {
    marginBottom: Theme.spacing.lg,
  },
});

